$(function () {
  // 各スライダーに対して、識別子を設定する
  const $mBlockDetailSlider1 = $(".m-block-detail-slider-1");
  const $mBlockDetailSlider2 = $(".m-block-detail-slider-2");
  const $mBlockDetailSlider3 = $(".m-block-detail-slider-3");

  // スライダーのオプションを設定する
  const slickOptions = {
    autoplay: false,
    speed: 800,
    autoplaySpeed: 4000,
    variableWidth: false,
    infinite: true,
    dots: true,
    centerMode: true,
    prevArrow: false,
    nextArrow: false,
    slidesToShow: 3, // PCサイズで3枚表示
    slidesToScroll: 1, // スライド1つずつ移動
    centerPadding: "7%",
    adaptiveHeight: true,
    rows: 0,
    slidesPerRow: 1,
    responsive: [
      {
        breakpoint: 576, // タブレットサイズ以下での設定
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 1100, // タブレットサイズ以下での設定
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
    ],
  };

  // スライダーの初期化と高さの調整を行う関数を定義する
  function initSlider($slider) {
    // スライダーを初期化する
    $slider.slick(slickOptions);
  }

  // それぞれのスライダーの初期化を行う
  initSlider($mBlockDetailSlider1);
  initSlider($mBlockDetailSlider2);
  initSlider($mBlockDetailSlider3);
});
